import React, { Suspense } from 'react';
import styled from 'types/theme.types';
import LoaderAnimationData from 'assets/images/animations/env0-loader.json';

const LottieComponent = React.lazy(() => import('lottie-react'));

export const loaderSizes = ['default', 'small', 'large'] as const;
export type LoaderSize = (typeof loaderSizes)[number];

export const loaderTypes = ['default', 'robot'] as const;
export type LoaderType = (typeof loaderTypes)[number];

export interface LoaderProps {
  size?: LoaderSize;
  type?: LoaderType;
  name?: string;
}

const SIZE_MAP: { [key in LoaderSize]: string } = {
  large: '150px',
  default: '100px',
  small: '50px'
};

export const Loader: React.FunctionComponent<LoaderProps> = ({ size = 'default' as const, name = 'loader' }) => {
  const animation = { data: LoaderAnimationData, id: 'default' };

  return (
    <Container data-e2e={name}>
      <AnimationContainer size={size} data-e2e={`animation-container-${size}`}>
        <Suspense fallback={<CssSpinner />}>
          <LottieComponent animationData={animation.data} data-e2e={`animation-${animation.id}`} loop autoPlay />
        </Suspense>
      </AnimationContainer>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AnimationContainer = styled.div<{ size: LoaderSize }>`
  height: ${({ size }) => SIZE_MAP[size]};
  width: ${({ size }) => SIZE_MAP[size]};
`;

const CssSpinner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    width: 32px;
    height: 32px;
    border: 3px solid #e0e0e0;
    border-top-color: #3498db;
    border-radius: 50%;
    animation: loader-spin 0.8s linear infinite;
  }

  @keyframes loader-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default Loader;
